import React from 'react';
import styled from 'styled-components';
import { HStack } from '~/components/ViewStacks';
import Text from '~/components/Text';
import Logo from '~/components/Logo';
import { CompetitorLogo } from '../CompetitorLogos';
import type { CompetitorType } from '../../types';

const LogoWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	width: 68px;
	height: 68px;
	padding: 11.5px 9.5px 11.5px 11.5px;
	border-radius: 100px;
	background: #e2ecff;
`;

const VsText = styled(Text)`
	color: ${({ theme }) =>
		theme.tokens.COLOR_TOKENS_TEXT_INVERTIBLE_NEUTRAL_NEUTRAL_STRONG};
	font-size: 32px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
`;

const StyledLogo = styled(Logo)`
	width: 43.1px;
	height: auto;
`;

interface StreamYardVsCompetitorLogosProps {
	competitor?: CompetitorType;
}

const StreamYardVsCompetitorLogos: React.FC<
	StreamYardVsCompetitorLogosProps
> = ({ competitor }) => {
	return (
		<HStack spacing={8}>
			<LogoWrapper>
				<StyledLogo variant="icon" />
			</LogoWrapper>
			<VsText variant="h2">vs</VsText>
			{competitor && <CompetitorLogo competitor={competitor} size={68} />}
		</HStack>
	);
};

export default StreamYardVsCompetitorLogos;
